import { render } from "./DropdownSingleSelect.vue?vue&type=template&id=5a89c7c8"
import script from "./DropdownSingleSelect.vue?vue&type=script&lang=js"
export * from "./DropdownSingleSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__